<script setup>
import { historyFormData, hisTaskForm } from "@/api/needDealt";
import { computed, onMounted, reactive, ref, watch } from "vue";
import { PROCESS_SUBMIT_TYPE_OBJECT } from "@/constants";

const props = defineProps(["operationLog", "backnodes"]);

const backNodeOptions = ref([]);

const reverse = ref(true);

const dialogFormRef = ref(null);

const dealtHis = reactive({
  title: "",
  open: false,
  hasFormConf: {},
  formData: {},
});

const logList = computed(() => {
  let result = [];
  props.operationLog.forEach((item) => {
    result.push(JSON.parse(item));
  });

  result.map((i) => {
    // i.operationLoginName = i.operationUser.nikeName;
    i.submitTypeStr = PROCESS_SUBMIT_TYPE_OBJECT[i.submitType];
  });
  console.log("list", result);
  return result;
});

const taskDetail = (taskId, taskName) => {
  dealtHis.title = taskName + "节点详情";
  hisTaskForm(taskId).then((res) => {
    const obj = res.data;
    dealtHis.hasFormConf = JSON.parse(obj.formContent);
    historyFormData(taskId)
      .then((res) => {
        console.log(res.data);
        dealtHis.formData = convertToJsonObj(res.data);
        dealtHis.open = true;
      })
      .finally(() => {
        dialogFormRef.value.disableForm();
        dialogFormRef.value.setFormJson(dealtHis.hasFormConf);
        dialogFormRef.value.setFormData(dealtHis.formData);
      });
  });
};
const convertToJsonObj = (arr) => {
  let obj = {};
  if (!Array.isArray(arr)) {
    return obj;
  }
  for (let i = 0; i < arr.length; i++) {
    let current = arr[i];
    obj[current.name] = current.textValue;
  }
  return obj;
};

onMounted(() => {
  dealtHis.hasFormConf = {
    fields: [
      {
        __config__: {
          label: "上传",
          tag: "el-upload",
          tagIcon: "upload",
          layout: "colFormItem",
          defaultValue: null,
          showLabel: true,
          labelWidth: null,
          required: true,
          span: 24,
          showTip: false,
          buttonText: "点击上传",
          regList: [],
          changeTag: true,
          fileSize: 2,
          sizeUnit: "MB",
          document: "https://element.eleme.cn/#/zh-CN/component/upload",
          formId: 101,
          renderKey: "1011670916427997",
        },
        __slot__: { "list-type": true },
        action: "https://jsonplaceholder.typicode.com/posts/",
        disabled: true,
        accept: "",
        name: "file",
        "auto-upload": true,
        "list-type": "text",
        multiple: false,
        __vModel__: "field101",
      },
    ],
    formRef: "elForm",
    formModel: "formData",
    size: "medium",
    labelPosition: "right",
    labelWidth: 100,
    formRules: "rules",
    gutter: 15,
    disabled: false,
    span: 24,
    formBtns: false,
  };
});

watch(
  () => props.backnodes,
  (newVal) => {
    backNodeOptions.value = newVal;
  },
  { immediate: true }
);
</script>

<template>
  <div id="taskOperationLog">
    <el-timeline :reverse="reverse">
      <el-timeline-item v-for="(item, index) in logList" :key="index">
        <div class="operationLogs">
          <!-- <div class="user-container">
            <div class="col-md-6">
              <img src="" class="user-image" />
            </div>
            <div class="col-md-6 user-info">
              <p>{{ item.operationLoginName }}</p>
              <p>{{ item.operationUserName }}</p>
            </div>
          </div> -->
          <div class="log">
            <p>
              【{{ item?.operationUser }}】在【{{ item.taskName }}】节点做了【{{
                item.submitTypeStr
              }}】操作<span
                v-if="item.backTarStr != null && item.backTarStr != 'null'"
                >>>>【{{ item.backTarStr }}】节点</span
              >
            </p>
            <p>操作时间：{{ item.operationTime }}</p>
          </div>
          <div class="col-md-1" style="width: 100px; padding: 9px">
            <el-button
              type="primary"
              plain
              @click="taskDetail(item.taskId, item.taskName)"
              >详情</el-button
            >
          </div>
        </div>
      </el-timeline-item>
    </el-timeline>

    <el-dialog
      :title="dealtHis.title"
      v-model="dealtHis.open"
      width="800px"
      append-to-body
    >
      <v-form-render
        ref="dialogFormRef"
        :form-json="dealtHis.hasFormConf"
        :form-data="dealtHis.formData"
      />
    </el-dialog>
  </div>
</template>

<style scoped>
#taskOperationLog {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  margin: 10px 0;
  padding: 20px 20px;
  overflow: auto;
  height: 400px;
}
#taskOperationLog > .operationLogs {
  border-bottom: 1px solid #ccc;
  overflow: hidden;
}
.user-container {
  width: 140px;
  display: flex;
  align-items: center;
}
.user-image {
  height: 50px;
  border-radius: 50%;
}
.user-info {
  padding: 0 10px;
  flex: 1;
  text-align: left;
}
.log {
  flex: 1;
}
p {
  margin: 0;
  line-height: 26px;
}
.operationLogs {
  overflow: hidden;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  display: flex;
}
</style>
